import { useMutation } from 'react-query';

import { API_CTX } from '@/config';
import { restoreURL } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

export type ConfirmUserDTO = {
  email: string;
};

export const confirmUser = ({ email }: ConfirmUserDTO) => {
  const safeEmail = encodeURIComponent(email);
  return restoreURL().post(
    `${API_CTX}/users/${safeEmail}/send-email-confirmation`
  );
};

type UseUpdateUserOptions = {
  onSuccess?: (...args: any[]) => void;
  config?: MutationConfig<typeof confirmUser>;
};

export const useConfirmEmail = ({
  config,
  onSuccess,
}: UseUpdateUserOptions) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['users']);
      if (onSuccess) {
        onSuccess?.();
      } else {
        addNotification({
          type: 'success',
          title: 'User Approved to proceed!',
        });
      }
    },
    ...config,
    mutationFn: (params) => {
      return confirmUser({ email: params.email });
    },
  });
};
